// Explicit local build option; production hosts always keep the normal announcement flow.
export const isGuidePreview = process.env.VUE_APP_GUIDE_PREVIEW === 'true'
  && ['127.0.0.1', 'localhost'].includes(window.location.hostname);
